import { render, staticRenderFns } from "./TeacherContract.vue?vue&type=template&id=3a22fb9a"
import script from "./TeacherContract.vue?vue&type=script&lang=js"
export * from "./TeacherContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a22fb9a')) {
      api.createRecord('3a22fb9a', component.options)
    } else {
      api.reload('3a22fb9a', component.options)
    }
    module.hot.accept("./TeacherContract.vue?vue&type=template&id=3a22fb9a", function () {
      api.rerender('3a22fb9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TeacherContract.vue"
export default component.exports